import React, { useState } from "react";
import { format } from "date-fns";
import { ICompletedTrainigs } from "./Table";
import { Fetch } from "../../../shared/Fetch";
import { Button } from "primereact/button";
import { TrainingRatingAnswers } from "./TrainingRatingAnswers";

interface RatingProps {
    singleData: ICompletedTrainigs;
    reloadTable: () => void,
    toast: any,
}

const TrainerRatingCard: React.FC<RatingProps> = (props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [rating, setRating] = useState<number>(props.singleData.rating || 0);
    const [hover, setHover] = useState<number>(0);
    const [feedback, setFeedback] = useState(props.singleData.feedback || "");
    const [openQuestionForm, setOpenQuestionForm] = useState({ open: false, singleData: {}, bodyData: {} } as {
        open: boolean, singleData: ICompletedTrainigs, bodyData: {
            Rating?: number,
            Feedback?: string,
            Schedule_ID?: number,
        }
    });

    const handleSubmit = () => {
        // if (rating === 0) {
        //     props.toast.current.show({ severity: 'error', detail: "Please select a rating before submitting!", life: 3000 });
        //     return;
        // } else
        //     handleRatingSubmit(rating, feedback);
        handleRatingSubmit(2, "");
    };

    const handleRatingSubmit = async (rating: number, feedback: string) => {
        if (rating === 1 && feedback.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: "Please write feedback for 1 star!", life: 3000 });
        } else if (rating === 5 && feedback.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: "Please write feedback for 5 star!", life: 3000 });
        } else {
            const newBodyData: {
                Rating: number,
                Feedback: string,
                Schedule_ID?: number,
            } = {
                Rating: rating,
                Feedback: feedback,
                Schedule_ID: props.singleData.schedule_ID,
            };
            setOpenQuestionForm({ open: true, singleData: props.singleData, bodyData: newBodyData });
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                {/* Trainer Header */}
                <div style={styles.header}>
                    <img
                        src={`https://hrmsapi.jobvritta.com/api/Hrlense_Employee/getEmployeeImages?EmployeeCode=${props.singleData?.trainer_User_Employee_ID}`}
                        style={styles.photo}
                        alt="trainer"
                    />
                    <div>
                        <h2>{props.singleData.trainerName}</h2>
                        <p>📚 <b>Category:</b> {props.singleData.category}</p>
                        <p>📚 <b>Topic:</b> {props.singleData.topic}</p>
                        <p>📆 <b>Date:</b> {format(new Date(props.singleData?.dateFrom || ""), 'dd/MM/yyyy').toUpperCase()} </p>
                        <p>⏰ <b>Time:</b> {format(new Date(props.singleData.timeFrom || ""), 'hh:mm  a').toUpperCase()} - {format(new Date(props.singleData.timeTo || ""), 'hh:mm  a').toUpperCase()} </p>
                        <p>🧑‍🏫 <b>Trainer:</b> {props.singleData.trainerName}</p>
                    </div>
                </div>

                {/* Rating Stars */}
                {/* <div style={styles.stars}>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <span
                            key={star}
                            onMouseEnter={() => { if (props.singleData.rating_ID === null) setHover(star); }}
                            onMouseLeave={() => { if (props.singleData.rating_ID === null) setHover(0); }}
                            onClick={() => {
                                if (props.singleData.rating_ID !== null && props.singleData.rating_ID !== undefined && props.singleData.rating_ID !== 0) {
                                    props.toast.current.show({ severity: 'error', detail: "Rating Have Been Already Submitted", life: 3000 });
                                }
                                else setRating(star);
                            }}
                            style={{
                                ...styles.star,
                                color: star <= (hover || rating) ? "#FFD700" : "#ccc",
                            }}
                        >
                            ★
                        </span>
                    ))}
                </div> */}

                {/* Feedback Box */}
                {/* {props.singleData.feedback === null && <textarea
                    placeholder="Write your feedback about the trainer..."
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    style={styles.textarea}
                    disabled={props.singleData.rating_ID !== null && props.singleData.rating_ID !== undefined && props.singleData.rating_ID !== 0}
                />} */}

                {/* {props.singleData.feedback !== null && props.singleData.feedback?.trim() !== "" && <div style={{ padding: "3rem", border: "1px solid #ffafbd", backgroundColor: "#fdfcfdff", borderRadius: "10px" }}>
                    <p style={{ color: "grey" }}>{props.singleData.feedback}</p>
                </div>} */}

                {props.singleData.answers && props.singleData.answers?.length > 0 && <Button label="View Answers" type="button" className="p-button-outlined surface-200 mt-3" onClick={() => setOpenQuestionForm({
                    open: true, singleData: props.singleData, bodyData: {
                        Rating: rating,
                        Feedback: feedback,
                        Schedule_ID: props.singleData.schedule_ID,
                    }
                })} />}

                {/* Submit Button */}
                {!(props.singleData.rating_ID !== null && props.singleData.rating_ID !== undefined && props.singleData.rating_ID !== 0) && <Button disabled={loading} loading={loading} onClick={handleSubmit} style={styles.button} label="Submit Rating" />}
            </div>
            <TrainingRatingAnswers open={openQuestionForm.open} singleData={openQuestionForm.singleData} bodyData={openQuestionForm.bodyData} removeStars={() => setRating(0)} hideDialog={() => {
                setOpenQuestionForm({ open: false, singleData: {}, bodyData: {} });
                setFeedback("");
            }} reloadTable={() => props.reloadTable()} toast={props.toast} />
        </div>
    );
};

// ------------------ Styles ---------------------------
const styles: Record<string, React.CSSProperties> = {
    container: {
        height: "285px",
        // width: "28%",
        display: "flex",
        justifyContent: "center",
        marginTop: "40px",
    },
    card: {
        width: "450px",
        height: "325px",
        padding: "24px",
        background: "#fff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        borderRadius: "12px",
        border: "2px solid #ffafbd",
        backgroundColor: "#fdf1f3ff",
        //paddingBottom: "20px"
    },
    header: {
        display: "flex",
        alignItems: "center",
        gap: "16px",
        marginBottom: "20px",
    },
    photo: {
        width: "80px",
        height: "80px",
        borderRadius: "50%",
        objectFit: "cover",
    },
    stars: {
        fontSize: "32px",
        marginBottom: "16px",
        display: "flex",
        gap: "8px",
        cursor: "pointer",
    },
    star: {
        cursor: "pointer",
        transition: "0.2s",
    },
    textarea: {
        width: "100%",
        height: "100px",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        marginBottom: "20px",
        resize: "none",
    },
    button: {
        width: "100%",
        padding: "12px",
        background: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "16px",
    },
};

export default TrainerRatingCard;